import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: '#7833FF',
  },
  personalInformation: {
    maxWidth: 500,
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(6),
  },
  circle: {
    display: 'inline-block',
    width: 30,
    height: 30,
    borderRadius: '50%',
    textAlign: 'center',
    lineHeight: '1.8rem',
    border: `1px solid ${theme.palette.text.secondary}`,
    color: theme.palette.text.secondary,
  },
  title: {
    margin: theme.spacing(0, 2),
  },
  divider: {
    flex: 'auto',
  },
  input: {
    backgroundColor: theme.palette.common.white,
  },
  fileButton: {
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    borderRadius: 40,
  },
  fileList: {
    width: 179,
    maxWidth: '100%',
  },
  fileListText: {
    '& span': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
}));
